import { t } from "@lingui/macro";
import * as React from "react";
import { Rect, Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const BusinessIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="#001A19"
    title={t`Business`}
    {...props}
  >
    <Rect
      width={14}
      height={8}
      x={1}
      y={6}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      rx={1}
      fill="none"
    />
    <Path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      fill="none"
      d="M6 9h4M5 4V3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1"
    />
  </Icon>
);
